<div class="pt-4">
  @if (isLoading()) {
    <div class="flex justify-center items-center h-40">
      <mat-spinner diameter="40" />
    </div>
  } @else {
    <p class="text-gray-600 mb-4">{{ 'waters.season-periods.default-hint' | translate }}</p>

    <app-season-period-table [rows]="rows()" (rowsChange)="onRowsChange($event)" />

    <div class="flex justify-end items-center gap-3 mt-4">
      @if (showValidationError()) {
        <span class="text-sm text-red-600">{{ 'waters.season-periods.invalid-hint' | translate }}</span>
      }
      <button mat-flat-button color="primary" [disabled]="isSaving()" (click)="save()">
        @if (isSaving()) {
          <mat-spinner diameter="18" />
        } @else {
          {{ 'waters.form.save' | translate }}
        }
      </button>
    </div>
  }
</div>
